/** @format */

import { Cta } from '@dcsg-ngx-ecommerce/engage';
export class WysiwygDetails {
	constructor(
		public cta: Cta,
		public headline: string,
		public wysiwyg: any
	) {
		this.cta = cta;
		this.headline = headline;
		this.wysiwyg = wysiwyg;
	}
}
